export default __webpack_public_path__ + "static/media/f0ad65e88c0ca9e87c037b353b8022491575984028682.53a151d2.webp";